import usePermittedQuery from '_api/queries/usePermittedQuery';
import { ContentSettingV2, Exercise } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_EXERCISE_CONTENT_BY_CONTENT_ID = 'get-exercise-content-by-content-id';

export const useGetExerciseContentByContentId = (contentId: number) => {
  return usePermittedQuery<ContentSettingV2<Exercise>>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/exercise/patient-exercise-setting/${contentId}`,
    {
      headers: {
        Accept: 'application/vnd.ysh.api.v2+json',
      },
    },
    [GET_EXERCISE_CONTENT_BY_CONTENT_ID],
    {
      enabled: typeof contentId === 'number' && contentId >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
